import { WorkflowAdditionalIncomeApplicantSubBaseService } from 'app/core/workflow/workflow-steps/applicant/sub/workflow-additional-income-applicant-sub-base.service';

export class WorkflowAdditionalIncomeFourService extends WorkflowAdditionalIncomeApplicantSubBaseService {
  public get title(): string {
    return 'ASIDE_BAR.CRYPTOCURRENCY';
  }

  public get subStepNumber(): number {
    return 4;
  }
}
